<div class="card-container">
    <div class="card-header-wrapper">
        <h3 class="card-title"> {{ customMsgService.translate('parametrosDoSistema') }} </h3>
        <span></span>
    </div>

    <div class="card-component">

        <form class="k-form k-form-horizontal" style="max-width: 700px;width: 700px;" [formGroup]="formGroup">
            <fieldset class="k-form-fieldset">

                <kendo-formfield orientation="horizontal">
                    <kendo-label class="k-label" [for]="UrlRecuperacaoPwd"
                        [text]="customMsgService.translate('UrlRecuperacaoPwd')"> </kendo-label>
                    <kendo-textbox formControlName="UrlRecuperacaoPwd" [clearButton]="true" #UrlRecuperacaoPwd required>
                    </kendo-textbox>
                    <kendo-formerror> Error: This field is required </kendo-formerror>
                </kendo-formfield>

                <kendo-formfield orientation="horizontal">
                    <kendo-label class="k-label" [for]="EmailSmtpServer"
                        [text]="customMsgService.translate('smtpServer')"> </kendo-label>
                    <kendo-textbox formControlName="EmailSmtpServer" [clearButton]="true" #EmailSmtpServer required>
                    </kendo-textbox>
                    <kendo-formerror> Error: This field is required </kendo-formerror>
                </kendo-formfield>

                <kendo-formfield orientation="horizontal">
                    <kendo-label [for]="EmailPort" [text]="customMsgService.translate('smtpPort')"> </kendo-label>
                    <kendo-textbox formControlName="EmailPort" [clearButton]="true" #EmailPort required>
                    </kendo-textbox>
                    <kendo-formerror> Error: This field is required </kendo-formerror>
                </kendo-formfield>
                <kendo-formfield orientation="horizontal">
                    <kendo-label [for]="EmailUsername" [text]="customMsgService.translate('EmailUsername')">
                    </kendo-label>
                    <kendo-textbox formControlName="EmailUsername" [clearButton]="true" #EmailUsername required>
                    </kendo-textbox>
                    <kendo-formerror> Error: This field is required </kendo-formerror>
                </kendo-formfield>

                <kendo-formfield orientation="horizontal">
                    <kendo-label [for]="EmailPassword" [text]="customMsgService.translate('smtpPass')"> </kendo-label>
                    <kendo-textbox formControlName="EmailPassword" [clearButton]="true" #EmailPassword required>
                    </kendo-textbox>
                    <kendo-formerror> Error: This field is required </kendo-formerror>
                </kendo-formfield>

                <kendo-formfield orientation="horizontal">
                    <kendo-label [for]="EmailFrom" [text]="customMsgService.translate('smtpFrom')"> </kendo-label>
                    <kendo-textbox #EmailFrom formControlName="EmailFrom"> </kendo-textbox>
                    <kendo-formerror> Error: This field is required </kendo-formerror>
                </kendo-formfield>

                <kendo-formfield orientation="horizontal">
                    <kendo-label class="k-label" [for]="Lingua" [text]="customMsgService.translate('ligua')">
                    </kendo-label>
                    <kendo-dropdownlist formControlName="Lingua" textField="description" valueField="id"
                        [defaultItem]="placeHolderLingua" [data]="linguas" #Lingua required>
                    </kendo-dropdownlist>
                    <kendo-formerror> Error: This field is required </kendo-formerror>
                </kendo-formfield>
                <hr />
                <div class="k-form-buttons">
                    <button kendoButton (click)="cancelChanges()">
                        {{ customMsgService.translate('cancel') }}
                    </button>
                    <button kendoButton [primary]="true" [disabled]="formGroup.invalid || formGroup.pristine"
                        (click)="saveChanges()">
                        {{ customMsgService.translate('saveChanges') }}
                    </button>
                </div>
            </fieldset>
        </form>


    </div>
</div>
<div kendoDialogContainer></div>